import React from "react";

export const checkMultiple = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="M392.533,0c-65.877,0-119.467,53.606-119.467,119.467s53.589,119.467,119.467,119.467S512,185.327,512,119.467
            S458.411,0,392.533,0z M392.533,204.8c-47.053,0-85.333-38.281-85.333-85.333s38.281-85.333,85.333-85.333
            c47.053,0,85.333,38.281,85.333,85.333S439.586,204.8,392.533,204.8z"
            fill="currentColor"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M477.867,392.533c0,47.053-38.281,85.333-85.333,85.333c-47.053,0-85.333-38.281-85.333-85.333
            c0-47.053,38.281-85.333,85.333-85.333v-34.133c-65.877,0-119.467,53.606-119.467,119.467S326.656,512,392.533,512
            S512,458.394,512,392.533H477.867z"
            fill="currentColor"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M204.8,119.467c0,47.053-38.281,85.333-85.333,85.333s-85.333-38.281-85.333-85.333s38.281-85.333,85.333-85.333V0
            C53.589,0,0,53.606,0,119.467s53.589,119.467,119.467,119.467s119.467-53.606,119.467-119.467H204.8z"
            fill="currentColor"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M119.467,273.067C53.589,273.067,0,326.673,0,392.533S53.589,512,119.467,512s119.467-53.606,119.467-119.467
            S185.344,273.067,119.467,273.067z M119.467,477.867c-47.053,0-85.333-38.281-85.333-85.333c0-47.053,38.281-85.333,85.333-85.333
            s85.333,38.281,85.333,85.333C204.8,439.586,166.519,477.867,119.467,477.867z"
            fill="currentColor"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M209.801,22.067l-90.334,90.334L97.399,90.334l-24.132,24.132l34.133,34.133c3.328,3.328,7.697,5.001,12.066,5.001
            s8.738-1.673,12.066-5.001l102.4-102.4L209.801,22.067z"
            fill="currentColor"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M482.867,295.134l-90.334,90.334l-22.067-22.067l-24.132,24.132l34.133,34.133c3.328,3.328,7.697,5.001,12.066,5.001
            c4.369,0,8.738-1.673,12.066-5.001l102.4-102.4L482.867,295.134z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
